import { FormControl, FormErrorMessage, FormLabel, Input, Select, Stack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { States } from '../../models';
import { CreateReportPropertyFormData } from '../../models/reports/input';
import { Location, useReportStore } from '../../providers/ReportProvider';
import { CardBody } from '../Card';
import { Section } from '../PropertyInformation';

export function PropertyLocation() {
  const {
    setValue,
    register,
    formState: { errors }
  } = useFormContext<CreateReportPropertyFormData>();

  const { location } = useReportStore();

  useEffect(() => {
    if (location) {
      Object.keys(location).forEach((key) =>
        setValue(key as keyof Location, location[key as keyof Location] || '')
      );
    }
  }, [setValue, location]);

  return (
    <Section>
      <CardBody>
        <div className="flex flex-row gap-x-4 justify-center">
          <Stack className="basis-2/3">
            <FormControl isInvalid={!!errors['street']?.message}>
              <FormLabel>Street Address</FormLabel>
              <Input
                {...register('street', {
                  onChange: (e) => setValue('street', e.target.value)
                })}
              />
              {errors['street']?.message && (
                <FormErrorMessage>{errors['street']?.message}</FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack className="basis-1/3">
            <FormControl isInvalid={!!errors['unit']?.message}>
              <FormLabel>Unit Number</FormLabel>
              <Input
                {...register('unit', {
                  onChange: (e) => setValue('unit', e.target.value)
                })}
              />
              {errors['unit']?.message && (
                <FormErrorMessage>{errors['unit']?.message}</FormErrorMessage>
              )}
            </FormControl>
          </Stack>
        </div>
        <div className="flex flex-row gap-x-4 justify-center">
          <Stack className="basis-1/3">
            <FormControl isInvalid={!!errors['city']?.message}>
              <FormLabel>City</FormLabel>
              <Input
                className="mr-2"
                {...register('city', {
                  onChange: (e) => setValue('city', e.target.value)
                })}
              />
              {errors['city']?.message && (
                <FormErrorMessage>{errors['city']?.message}</FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack className="basis-1/3">
            <FormControl isInvalid={!!errors['state']?.message}>
              <FormLabel>State</FormLabel>
              <Select
                {...register('state', {
                  onChange: (e) => setValue('state', e.target.value)
                })}
              >
                {Object.values(States).map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </Select>
              {errors['state']?.message && (
                <FormErrorMessage>{errors['state']?.message}</FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack className="basis-1/3">
            <FormControl isInvalid={!!errors['zipCode']?.message}>
              <FormLabel>Zip Code</FormLabel>
              <Input
                className="ml-2"
                {...register('zipCode', {
                  onChange: (e) => setValue('zipCode', e.target.value)
                })}
              />
              {errors['zipCode']?.message && (
                <FormErrorMessage>{errors['zipCode']?.message}</FormErrorMessage>
              )}
            </FormControl>
          </Stack>
        </div>
      </CardBody>
    </Section>
  );
}

export default PropertyLocation;
